import { Directive, Inject, ElementRef, HostListener, Optional, DOCUMENT } from '@angular/core';
import { NgxMaskDirective, NgxMaskService } from 'ngx-mask';

import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pcgTime]',
    providers: [NgxMaskService],
    standalone: false
})
export class TimeDirective extends NgxMaskDirective {

	constructor(@Inject(DOCUMENT) document: any, maskService: NgxMaskService,
		private elRef: ElementRef, @Optional() private control: NgControl) {
		super();

		this.maskExpression = '09:00 SS';
	}

	@HostListener('change')
	changeEvent() {
		if (!this.isValidTime(this.elRef.nativeElement.value)) {
			this.elRef.nativeElement.value = '';
		}
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}

	@HostListener('keyup')
	keyEvent() {
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}

	// Expect input as mm:hh AM/PM
	isValidTime(s: string) {
		const timePart = s.split(':');
		if (timePart.length !== 2) {
			return false;
		}
		const amPmSplit = timePart[1].split(' ');
		if (amPmSplit.length !== 2) {
			return false;
		}

		if (amPmSplit[1].toLowerCase() !== 'pm' && amPmSplit[1].toLowerCase() !== 'am') {
			return false;
		}

		if (parseInt(timePart[0], null) < 1 || parseInt(timePart[0], null) > 12 ||
			parseInt(amPmSplit[0], null) > 59 || parseInt(amPmSplit[0], null) < 0) {
				return false;
		}
		return true;
	}
}
